import { DesignObligation, Inclusion, MaturityStage, ProductBuildingBlock } from '@/gql/graphql';

type WithMetadata<T> = {
  data: T[];
  count: number;
};

export enum SortByEnum {
  DO = 'DO',
  MTS = 'MTS',
}

export type SortBy = keyof typeof SortByEnum;

export type GroupedBuildingBlock<T> = T & {
  buildingBlocks: ProductBuildingBlock[];
};

export type SortedBuildingBlock<T> = WithMetadata<GroupedBuildingBlock<T>>;

export const filterIncludedBuildingBlocks = (bb?: ProductBuildingBlock[]): ProductBuildingBlock[] => {
  if (!bb) return [];
  return bb.filter((bb) => {
    return bb.inclusion.actual === Inclusion.Included || bb.inclusion.actual === Inclusion.Pending;
  });
};

export const fiterExcludedBuildingBlocks = (bb?: readonly ProductBuildingBlock[]): ProductBuildingBlock[] => {
  if (!bb) return [];
  return bb.filter((bb) => {
    return bb.inclusion.actual === Inclusion.Excluded;
  });
};

export const sortByDesignObligation = (bbs: ProductBuildingBlock[]): SortedBuildingBlock<DesignObligation> => {
  const dos: SortedBuildingBlock<DesignObligation> = {
    count: bbs.length,
    data: [],
  };
  bbs.forEach((bb) => {
    const designObligation = bb.designObligation;
    if (!designObligation) return;

    const existingDO = dos.data.find((dosDo) => dosDo.id === designObligation.id);
    if (existingDO) {
      existingDO.buildingBlocks.push(bb);
    } else {
      dos.data.push({ ...designObligation, buildingBlocks: [bb] });
    }
  });

  dos.data.sort((a, b) => a.name.localeCompare(b.name));
  return dos;
};

export const sortByMaturityStage = (bbs: ProductBuildingBlock[]): SortedBuildingBlock<MaturityStage> => {
  const mts: SortedBuildingBlock<MaturityStage> = {
    count: bbs.length,
    data: [],
  };
  bbs.forEach((bb) => {
    const maturityStages = bb.maturityStages;
    if (!maturityStages) return;
    maturityStages.forEach((mt) => {
      const existingMT = mts.data.find((mtsMt) => mtsMt.id === mt.id);
      if (existingMT) {
        existingMT.buildingBlocks.push(bb);
      } else {
        mts.data.push({ ...mt, buildingBlocks: [bb] });
      }
    });
  });

  mts.data.sort((a, b) => {
    if (!a.id || !b.id) return 0;
    return parseInt(a.id.split('_')[1]) - parseInt(b.id.split('_')[1]);
  });
  return mts;
};
